import { render, staticRenderFns } from "./LiveChat.vue?vue&type=template&id=136a405d"
import script from "./LiveChat.vue?vue&type=script&lang=ts"
export * from "./LiveChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports